<div class="container">
  <mat-card style="margin-top: 50px">
    <mat-card-content style="margin-left: auto; margin-right: auto">
      <h1 class="mt-5">Preferences</h1>

      <h2 class="mt-4">ADM email notifications</h2>
      <p class="text-muted">
        We email you when an Agent Data Model you have access to has been updated with new data. Turn off the ones you
        don't want to hear about.
      </p>

      <div *ngIf="loadingData"><i class="fas fa-spinner fa-pulse"></i> Loading, Please Wait...</div>

      <div *ngIf="!loadingData && admPreferences.length === 0" class="text-muted">
        You don't have access to any Agent Data Models yet.
      </div>

      <ng-container *ngIf="!loadingData && admPreferences.length > 0">
        <div class="row">
          <div class="col-md-6 mainLabel">Agent Data Model</div>
          <div class="col-md-3 mainLabel">Subscription</div>
          <div class="col-md-3 mainLabel">Email me when it's updated</div>
        </div>
        <div class="row table-row" *ngFor="let preference of admPreferences">
          <div class="col-md-6" style="margin-top: 5px">{{ preference.name }}</div>
          <div class="col-md-3" style="margin-top: 5px">{{ preference.subscriptionName }}</div>
          <div class="col-md-3">
            <mat-checkbox
              [checked]="preference.emailOnUpdate"
              [disabled]="saving.has(preference.admLayoutId)"
              (change)="setAdmEmail(preference, $event.checked)"
              [attr.aria-label]="'Email me when ' + preference.name + ' is updated'">
            </mat-checkbox>
          </div>
        </div>
      </ng-container>
    </mat-card-content>
  </mat-card>
</div>
